<template>
  <div class="4c">
    <h3 class="uk-margin-medium-top">4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS</h3>
    
    <form id="form" class="uk-text-left">
        <p > <b>Ingresos Mensuales</b> </p>


      <div >
        <div class="uk-margin">
          <label class="uk-inline">Sueldo</label><input  type="number" v-model="data['Sueldo']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Otros Ingresos (esposa,hijos,negocio)</label><input  type="number"  v-model="data['Otros Ingresos']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>

        <div class="uk-margin">
          <p>
            <span class="uk-text-left">Ingreso Total (considerando imprevistos)</span> <span class="uk-margin-medium-left"> {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(ingresos)}}</span>
          </p>
          
        </div>

      </div>


        <hr>

        <p> <b>Gastos de la unidad familiar</b> </p>


        <div class="uk-margin">
          <label class="uk-inline">Alimentación</label><input  type="number"  v-model="data['Alimentación']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        
        <div class="uk-margin">
          <label class="uk-inline">Vestimenta y calzado</label><input  type="number"  v-model="data['Vestimenta y calzado']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Vivienda (Renta, Predial)</label><input  type="number"  v-model="data['Vivienda']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Servicios básicos (luz, agua, gas)</label><input  type="number"  v-model="data['Servicios']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Salud</label><input  type="number"  v-model="data['Salud']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Educación</label><input  type="number"  v-model="data['Educación']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Internet / Planes Celulares / Programas / Aplicaciones</label><input  type="number"  v-model="data['Celular o internet']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Transporte / gasolina</label><input  type="number"  v-model="data['Transporte']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Otros Gastos</label><input  type="number"  v-model="data['Otros Gastos']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">Imprevistos</label><input disabled type="text"  class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="%10" step="0.01" >
        </div>

        <hr>

      <p style="background-color:yellow; color:darkred" class="uk-margin uk-text-center"> 
        <b>
          Ahorro disponible para préstamos (Ingresos - Egresos - Deudas ) <br>
          {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(disp)}}
        </b>
         <b  v-if="act == 'Agricultor / Ganadero'">
         <br>
          Ahorro prorrateado por meses <br>
          {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(disp / data['Período de siembra-cosecha o venta'])}}
        </b>
      </p>
     


        <hr>

        <p><b>Datos del crédito solicitado</b></p>


        <div class="uk-margin">
          <label class="uk-inline">MONTO SOLICITADO</label><input  type="number" v-model="data['Monto solicitado']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="$" step="0.01" >
        </div>

        <div class="uk-margin">
          <label class="uk-inline">PLAZO EN MESES</label>
          <input type="number" placeholder="Meses"  v-model="data['Plazo']"  class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" >
        </div>
        <div class="uk-margin">
          <label class="uk-inline">FRECUENCIA DE PAGO</label>
          <select id="frec"   v-model="data['Frecuencia Pago']"  class="uk-select uk-margin-medium-left uk-inline uk-form-width-medium" >
            <option id="frecv" value="1">Mensual</option>
            <option value="4">Semanal</option>
            <option value="2">Quincenal</option>
            <option value=".5">Bimestral</option>
            <option value=".333">Trimestral</option>
            <option value=".25">Cuatrimestral</option>
            <option value=".166">Semestral</option>
            <option value=".083">Anual</option>
          </select>
        </div>

        <div class="uk-margin">
          <label class="uk-inline">TASA DE INTERÉS ANUAL</label> <input disabled type="number" step="0.01" v-model="data['Tasa']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="%"  >
        </div>


        <div class="uk-margin">
          <p>CUOTA DEL PRÉSTAMO &nbsp; <b class="uk-margin-medium-left">  &nbsp; {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(pago)}}</b></p>
          
        </div>




        <hr>

        <p><b>Cálculo de capacidad de
pago para pre aprobación de crédito</b></p>

        <p>Saldo disponible para créditos (Ingresos - egresos - deudas) <span class="uk-margin-medium-left"> <b>{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(disp)}}</b> </span></p>

        <div class="uk-margin">
          <label class="uk-inline">Porcentaje máximo destinado al pago del crédito</label> %<input disabled type="number" step="0.01" max="100" v-model="data['Porcentaje']" class="uk-input uk-margin-medium-left uk-inline uk-form-width-medium" placeholder="%50"  >
        </div>

        <p>
          Saldo destinado al pago del créduio  <span class="uk-margin-medium-left">{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(dest)}}</span>
        </p>

        <p>Cálculo de amortización <span class="uk-margin-medium-left">{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cuota)}}</span></p>

      <span class="uk-text-left">COBERTURA: SALDO DISPONIBL vs ERELACION CUOTA</span> <span class="uk-margin-medium-left">{{rel}}%</span>

        <p v-if="rel > 100" class="uk-text-center" style="color:darkgreen">
          Pre Aprobado
        </p>
        <p v-else style="color:darkred" class="uk-text-center">
          No puede pagar, revisar plazo o monto
        </p>


      <div class="uk-margin uk-text-center">
         <button  class="uk-button uk-button-primary">siguiente</button>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  data: function(){
    return {
      data : {},
      asalariado : true,
      act : this.$score.act,
      plazo : this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS'] ? parseFloat(this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Plazo'])  : '',
      cuota : 0.0,
    }
  },
  watch:{
    pago : function(val){
      this.cuota = val
      this.data['Cuota mensual'] = val
    }
  },
  computed:{
    ingresos:function(){
      var ing = 0.0
      

        if( !isNaN(this.data['Sueldo']) && this.data['Sueldo'] != '') ing += parseFloat(this.data['Sueldo']) 
        if( !isNaN(this.data['Otros Ingresos'])  && this.data['Otros Ingresos'] != '') ing += parseFloat(this.data['Otros Ingresos']) 
      


      this.data['Total Ingresos'] = (ing * .9).toFixed(2) 
      this.data['Ingresos'] = (ing).toFixed(2) 

      return (ing * .9).toFixed(2) 
    },
    gastos:function(){
      var ing = 0.0
        if(!isNaN(this.data['Alimentación']) && this.data['Alimentación'] != '' ) ing += parseFloat(this.data['Alimentación']) 
        if(!isNaN(this.data['Vestimenta y calzado']) && this.data['Vestimenta y calzado'] != '' ) ing += parseFloat(this.data['Vestimenta y calzado'])  
        if(!isNaN(this.data['Salud']) && this.data['Salud'] != '' ) ing += parseFloat(this.data['Salud']) 
        if(!isNaN(this.data['Educación']) && this.data['Educación'] != '' ) ing += parseFloat(this.data['Educación']) 
        if(!isNaN(this.data['Vivienda']) && this.data['Vivienda'] != '' ) ing += parseFloat(this.data['Vivienda'])
        if(!isNaN(this.data['Servicios']) && this.data['Servicios'] != '' ) ing += parseFloat(this.data['Servicios']) 
        if(!isNaN(this.data['Celular o internet']) && this.data['Celular o internet'] != '' ) ing += parseFloat(this.data['Celular o internet']) 
        if(!isNaN(this.data['Transporte']) && this.data['Transporte'] != '' ) ing += parseFloat(this.data['Transporte'])
        if(!isNaN(this.data['Otros Gastos']) && this.data['Otros Gastos'] != '' ) ing += parseFloat(this.data['Otros Gastos'])


        if(this.$score){
          if(this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']){
            if(!isNaN(this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']['Pago Mensual Total'] ) && this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']['Pago Mensual Total'] != '' ) ing += parseFloat(this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']['Pago Mensual Total'])
          }
        }

      if(isNaN(ing)){
        return 0
      }

      this.data['Total Gastos'] = ing.toFixed(2)
      return ing.toFixed(2)
    },
    disp:function(){
      var dis = this.ingresos - this.gastos
      if(isNaN(dis)){
        return 0
      }
      this.data['Saldo Disponible'] = dis.toFixed(2)
      return (dis.toFixed(2))
    },
    rel:function(){
      var dis = (this.disp * this.data['Porcentaje']/100) / this.cuota
      if(isNaN(dis)){
        return 0
      }
      dis = dis * 100.0
      this.data['Relación entre cuota y disponible'] = dis.toFixed(2)
      return (dis.toFixed(2))
    },
    
    pago : function() {
      
      try{
        
                var frec = parseFloat(this.data['Frecuencia Pago']);
                var plazo = parseFloat(this.data['Plazo'])
                var monto = parseFloat(this.data['Monto solicitado'])
                var tasa = parseFloat(this.data['Tasa'])



                var principal = monto
                var interest = tasa / 100 / 12;
                var payments = parseFloat(this.data['Frecuencia Pago']) * plazo;

                var x = Math.pow(1 + interest, payments);
                var P = (principal*x*interest)/(x-1);


      } catch (e) {

        return 0

      }
      if(isNaN(P)){
        return 0
      }
      return P.toFixed(2);
    },
    dest:function() {
      var val = (this.disp * this.data['Porcentaje']/100)
      if(isNaN(val)){
        return 0 
      }
      this.data["Saldo disponible"] = val
      return val
    },
    cali:function(){
      var calif

      switch (true) {
        case this.rel > 200:
          calif = 7
          break;
        case this.rel > 175:
          calif = 6
          break;
        case this.rel > 150:
          calif = 5
          break;
        case this.rel > 130:
          calif = 4
          break;
        case this.rel > 120:
          calif = 3
          break;
        case this.rel > 110:
          calif = 2
          break;
        case this.rel > 100:
          calif = 1
          break;
      
        default:
          calif = 0
          break;
      }

      this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS'] = this.data
      this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['PUNTAJE TOTAL'] = (parseFloat(calif) * 100.0 / 7.0).toFixed(2)
      return calif
    },

  },
  mounted: function(){
    document.getElementById('form').addEventListener('submit',function(e){
      e.preventDefault()
      var cal = this.cali + 1
      sessionStorage.setItem('score',JSON.stringify(this.$score))
      this.$router.push('5c')
    }.bind(this))
    window.scroll(0,0)
    this.$score = JSON.parse(sessionStorage.getItem('score'))
    if(this.$score){
      if(this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']) this.data = this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']
      if(this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']) this.data['Pago deudas'] = this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES']['Pago Mensual Total']
    }
    if(!this.data) this.data = {}
    this.$set(this.data, 'Porcentaje', 80)
    this.$set(this.data, 'Tasa', 18)
    this.$set(this.data, 'Frecuencia Pago', 1)
    document.getElementById('frec').value = 1
    document.getElementById('frecv').setAttribute('selected', true)
  } 
}
</script>
